export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d])[A-Za-z\d\S]{8,}$/;
export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const passwordRules = {
    minLength: 6,
    uppercase: /[A-Z]/,
    lowercase: /[a-z]/,
    number: /\d/,
    specialChar: /[@$!]/, // you can expand special chars as needed
};

export function validatePassword(password: string): boolean {
    return passwordRegex.test(password);
}

export function validateEmail(email: string): boolean {
    return emailRegex.test(email);
}

export function getPasswordRulesDescription(): string {
    return `Password must be at least ${passwordRules.minLength} characters long, including 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character (e.g., @, $, !).`;
}

// return detailed error messages
export function getPasswordErrors(password: string): string[] {
    const errors: string[] = [];
    if (password.length < 8) errors.push("Password must be at least 8 characters");
    if (!/[A-Z]/.test(password)) errors.push("Password must contain an uppercase letter");
    if (!/\d/.test(password)) errors.push("Password must contain a number");
    return errors;
}

export function checkImageURL(url: string): boolean {
    return /\.(jpeg|jpg|png|gif|webp|svg|avif|ico)$/i.test(url);
  }